import { FC } from "react";
import { IconProps } from "./types";

export const SocialYoutube: FC<IconProps> = ({
  fill = "#000",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M20.48 8.715a2.494 2.494 0 0 0-2.482-2.506A132.095 132.095 0 0 0 12 6.09c-2.04-.003-4.039.036-5.998.118A2.495 2.495 0 0 0 3.52 8.715 44.046 44.046 0 0 0 3.405 12c0 1.096.033 2.191.115 3.286a2.494 2.494 0 0 0 2.482 2.505c1.956.084 3.955.122 5.999.117 2.04.005 4.04-.034 5.997-.116a2.494 2.494 0 0 0 2.482-2.506c.082-1.095.119-2.191.115-3.286a45.709 45.709 0 0 0-.114-3.286zM9.853 15.76V8.24L15.224 12l-5.372 3.76z"
      fill={fill}
    />
  </svg>
);
